(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custome-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('cpg-avail-filter')) return;

    var section = e.target.closest('.cpg-page');
    if (!section) return;

    var showIn = section.querySelector('[data-avail="in"]').checked;
    var showOut = section.querySelector('[data-avail="out"]').checked;
    var cards = section.querySelectorAll('.cpg-card');

    cards.forEach(function (card) {
      var available = card.getAttribute('data-available') === 'true';
      var shouldShow = (available && showIn) || (!available && showOut);
      card.style.display = shouldShow ? '' : 'none';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-purchase-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.cprInit === '1') return;
      root.dataset.cprInit = '1';

      var toast = root.querySelector('[data-toast]');
      var items = Array.prototype.map.call(root.querySelectorAll('[data-items] li'), function (li) {
        return {
          title: li.dataset.title, url: li.dataset.url, img: li.dataset.img,
          loc: li.dataset.loc, name: li.dataset.name, when: li.dataset.when
        };
      });
      if (!items.length) return;

      try { if (sessionStorage.getItem('cpr-dismissed') === '1') return; } catch (e) {}

      var style = root.dataset.style;
      var firstDelay = (parseInt(root.dataset.firstDelay, 10) || 6) * 1000;
      var showFor = (parseInt(root.dataset.showFor, 10) || 6) * 1000;
      var gap = (parseInt(root.dataset.gap, 10) || 14) * 1000;
      var random = root.dataset.random === 'true';
      var loop = root.dataset.loop === 'true';
      var showTime = root.dataset.time === 'true';

      var order = items.map(function (_, i) { return i; });
      if (random) order.sort(function () { return Math.random() - 0.5; });
      var pos = 0;
      var stopped = false;
      var timers = [];

      function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

      function line(it) {
        if (style === 'loved') return 'Popular with pet parents in ' + it.loc;
        return it.name ? (it.name + ' from ' + it.loc + ' just bought') : ('Someone in ' + it.loc + ' just bought');
      }

      function fill(it) {
        toast.querySelector('[data-line]').textContent = line(it);
        toast.querySelector('[data-title]').textContent = it.title;
        toast.querySelector('[data-link]').href = it.url;
        var img = toast.querySelector('[data-img]');
        if (it.img) { img.src = it.img; img.alt = it.title; img.parentNode.style.display = ''; }
        else { img.parentNode.style.display = 'none'; }
        var when = toast.querySelector('[data-when]');
        var show = showTime && style !== 'loved' && it.when;
        when.textContent = show ? it.when : '';
        when.parentNode.style.display = show ? '' : 'none';
      }

      function lift() {
        /* keep clear of the product page sticky buy bar */
        var bar = document.querySelector('.cpp-sticky.is-visible');
        toast.style.bottom = bar ? (bar.offsetHeight + 16) + 'px' : '';
      }

      function cycle() {
        if (stopped) return;
        var it = items[order[pos]];
        fill(it);
        lift();
        toast.hidden = false;
        void toast.offsetWidth;
        toast.classList.add('is-in');

        later(function () {
          toast.classList.remove('is-in');
          later(function () {
            toast.hidden = true;
            pos++;
            if (pos >= order.length) {
              if (!loop) return;
              pos = 0;
            }
            later(cycle, gap);
          }, 600);
        }, showFor);
      }

      root.querySelector('[data-close]').addEventListener('click', function () {
        stopped = true;
        timers.forEach(clearTimeout);
        toast.classList.remove('is-in');
        setTimeout(function () { toast.hidden = true; }, 500);
        try { sessionStorage.setItem('cpr-dismissed', '1'); } catch (e) {}
      });

      later(cycle, firstDelay);
    }

    function initAll() { document.querySelectorAll('[data-cpr]').forEach(init); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
